export default {"src":"/_next/static/media/email_sent.77621e22.svg","height":71,"width":73,"blurWidth":0,"blurHeight":0};